/* eslint-disable */
const softWareSolutionsInit = (element: any) => {
  const solutions: HTMLElement[] = element.querySelectorAll(".small-solution");
  const center: HTMLElement = element.querySelector(
    ".software-solutions__ball"
  );
  let i = 0;

  const drawLine = (from: any, to: any, line: any) => {
    const fT = from.offsetTop + from.offsetHeight / 2;
    const tT = to.offsetTop + to.offsetHeight / 2;
    const fL = from.offsetLeft + from.offsetWidth / 2;
    const tL = to.offsetLeft;

    const CA = Math.abs(tT - fT);
    const CO = Math.abs(tL - fL);
    const H = Math.sqrt(CA * CA + CO * CO);
    let ANG = (180 / Math.PI) * Math.acos(CA / H);

    if (tT > fT) {
      var top = (tT - fT) / 2 + fT;
    } else {
      var top = (fT - tT) / 2 + tT;
    }
    if (tL > fL) {
      var left = (tL - fL) / 2 + fL;
    } else {
      var left = (fL - tL) / 2 + tL;
    }

    if (
      (fT < tT && fL < tL) ||
      (tT < fT && tL < fL) ||
      (fT > tT && fL > tL) ||
      (tT > fT && tL > fL)
    ) {
      // eslint-disable-line
      ANG *= -1;
    }
    top -= H / 2;

    line.style["-webkit-transform"] = `rotate(${ANG}deg)`;
    line.style["-moz-transform"] = `rotate(${ANG}deg)`;
    line.style["-ms-transform"] = `rotate(${ANG}deg)`;
    line.style["-o-transform"] = `rotate(${ANG}deg)`;
    line.style["-transform"] = `rotate(${ANG}deg)`;
    line.style.top = `${top}px`;
    line.style.left = `${left}px`;
    line.style.height = `${H}px`;
  };

  solutions.forEach((solution: HTMLElement) => {
    const line = document.createElement("div");
    line.classList.add("software-solutions__line");
    element.appendChild(line);
    drawLine(solution, center, line);

    solution.addEventListener("mouseover", () => {
      line.classList.add("active");
    });

    solution.addEventListener("mouseout", () => {
      line.classList.remove("active");
    });

    window.addEventListener("resize", () => {
      drawLine(solution, center, line);
    });

    i++;
  });

  const solutionsCarousel: HTMLElement = document.querySelector(
    ".software-solutions__desktop"
  );
  const carouselItems: Array<HTMLElement> = Array.from(
    solutionsCarousel.querySelectorAll(".small-solution")
  );

  const calculateCarouselPositions = () => {
    if (solutionsCarousel) {
      const maxHeight = solutionsCarousel.offsetHeight;
      const totalItems = carouselItems.length;

      for (let i = 0; i < totalItems; i++) {
        let angle = (i / (totalItems - 1)) * Math.PI - Math.PI / 2;
        let cosineValue = Math.cos(angle);
        let normalizedScore = (cosineValue + 1) / 2;

        carouselItems[i].style.bottom =
          maxHeight * normalizedScore - maxHeight / 2 + "px";
        carouselItems[i].setAttribute;
      }
    }
  };

  calculateCarouselPositions();
  window.addEventListener("resize", calculateCarouselPositions);
};

export default softWareSolutionsInit;
